import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundaries } from "logger/ErrorBoundaries";
import { AuthContextProvider } from "auth/Auth";
import { Provider } from "react-redux";
import { store, persistor } from "redux/store";
import { PersistGate } from "redux-persist/integration/react";
import "./assets/css/App.css";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import "./assets/css/index.css";

//import "../src/locale/i18nextInit"
// import "slick-carousel/slick/slick.css"; 
// import "slick-carousel/slick/slick-theme.css";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <BrowserRouter basename="/VisageClubCar">
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AuthContextProvider>
          <ErrorBoundaries>
            <App />
          </ErrorBoundaries>
        </AuthContextProvider>
      </PersistGate>
    </Provider>
  </BrowserRouter>
);
